import { render, staticRenderFns } from "./SummaryTitle.vue?vue&type=template&id=3eca346c&scoped=true&"
import script from "./SummaryTitle.vue?vue&type=script&lang=js&"
export * from "./SummaryTitle.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTitle.vue?vue&type=style&index=0&id=3eca346c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca346c",
  null
  
)

export default component.exports